import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import RouteConfig from '../config/appRoute/RouteConfig';
import { SUB_FUNCTION } from '../constants/APDConstants';
import EventManagementComponent from '../components/event';
import EventManagementDetail from '../components/event/event-detail';
import EventManagementCreate from '../components/event/event-create-edit';

function EventManagement({ authenRdc }) {
    const router = [];

    router.push(
        <Route
            key={RouteConfig.EVENT_MANAGEMENT}
            exact
            path={RouteConfig.EVENT_MANAGEMENT}
            component={EventManagementComponent}
        />
    );
    router.push(
        <Route
            key={RouteConfig.EVENT_MANAGEMENT_DETAIL}
            path={RouteConfig.EVENT_MANAGEMENT_DETAIL}
            component={EventManagementDetail}
        />
    );
    if (
        authenRdc.profile.subFunctions.some(
            (fn) =>
                fn.subFunctionId === SUB_FUNCTION.EVENT_CREATE ||
                fn.subFunctionId === SUB_FUNCTION.EVENT_ADMIN
        )
    ) {
        router.push(
            <Route
                key={RouteConfig.EVENT_MANAGEMENT_CREATE}
                path={RouteConfig.EVENT_MANAGEMENT_CREATE}
                component={EventManagementCreate}
            />
        );
    }
    router.push(
        <Route
            key={RouteConfig.EVENT_MANAGEMENT_EDIT}
            path={RouteConfig.EVENT_MANAGEMENT_EDIT}
            component={EventManagementCreate}
        />
    );

    return (
        <Switch>
            {router}
            <Route
                render={() => <Redirect to={RouteConfig.EVENT_MANAGEMENT} />}
            />
        </Switch>
    );
}

const mapStateToProps = (state) => ({
    authenRdc: state.authen,
});

export default connect(mapStateToProps)(EventManagement);
